import { Component, OnInit } from '@angular/core';
import { ApiResponse } from '../../../models/api-response.model';
import { WatchListNotificationViewModel, WatchListItemNew, WatchListViewModel } from '../../../models/watch-list.model';
import { WatchListService } from '../../../services/watch-list.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-notification-watchlist',
  templateUrl: './notification-watchlist.component.html',
  styleUrls: ['./notification-watchlist.component.css']
})
export class NotificationWatchlistComponent implements OnInit {

  title: string = 'WATCH LIST NOTIFICATIONS';
  stockCode: string;
  product: WatchListItemNew;
  sohEmail: boolean = false;
  sohAlert: boolean = false;
  priceEmail: boolean = false;
  priceAlert: boolean = false;
  sohSatisfy: boolean = false;
  priceSatisfy: boolean = false;
  sohCondition: string = 'Less Than';
  priceCondition: string = 'Less Than';
  productViewModel: WatchListNotificationViewModel;
  watchListViewModel: WatchListNotificationViewModel;
  priceValue: string = '0';
  sohValue: string = '0';
  loadContent: boolean = false;
  sohConditionList: any[] = [{ label: "Less Than", value: "Less Than" }, { label: "Equal", value: "Equal" }, { label: "Greater Than", value: "Greater Than" }];
  sohPriceList: any[] = [{ label: "Less Than", value: "Less Than" }, { label: "Equal", value: "Equal" }, { label: "Greater Than", value: "Greater Than" }];

  constructor(
    private watchListService: WatchListService,
    private router: Router,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    this.loadContent = false;

    $('#levelOne').animate({ scrollLeft: $('.sidebar-loader').width() + $('#watchlist').width() }, 400);

    this.activatedRoute.paramMap.subscribe(value => {
      this.stockCode = value.get('sku');
      this.watchListService.getWatchList().subscribe(ps => {
        if (ps) {
          this.product = ps.filter(x => x.out_stock_code == this.stockCode)[0];
        } else {
          this.close();
        }
        this.loadContent = true;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });

      this.watchListService.GetWatchListViewModel().subscribe((res: WatchListViewModel) => {
        if(res && res.notifications){
          this.watchListViewModel = res.notifications.filter(x => x.stockCode == this.stockCode)[0];
          this.sohEmail = this.watchListViewModel.sohEmail;
          this.sohAlert = this.watchListViewModel.sohAlert;
          this.priceEmail = this.watchListViewModel.priceEmail;
          this.priceAlert = this.watchListViewModel.priceAlert;
          this.sohCondition = this.watchListViewModel.sohCondition;
          this.priceCondition = this.watchListViewModel.priceCondition;
          this.sohValue = this.watchListViewModel.sohValue.toString();
          this.priceValue = this.watchListViewModel.priceValue.toString();
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    });
  }

  saveNotification(product: WatchListItemNew) {
    this.loadContent = false;
    this.productViewModel = {
      stockCode: product.out_stock_code,
      sohCondition: this.sohCondition,
      sohValue: this.commonService.toNumber(this.sohValue),
      sohEmail: this.sohEmail,
      sohAlert: this.sohAlert,
      priceCondition: this.priceCondition,
      priceValue: this.commonService.toNumber(this.priceValue),
      priceEmail: this.priceEmail,
      priceAlert: this.priceAlert,
      sohSatisfy: this.sohSatisfy,
      priceSatisfy: this.priceSatisfy
    };

    this.watchListService.updateWatchListNotification(this.productViewModel)
      .subscribe((data: ApiResponse) => {
        if(data.status){
          this.commonService.implementToast(data.responseMessage, "Success");
          this.loadContent = true;
        }else{
          this.commonService.implementToast(data.responseMessage, "Error");
          this.loadContent = true;
        }
      },
        (error: any) => {
          this.commonService.implementToast(error.error.responseMessage, "Error");
          this.loadContent = true;
        });
  }

  deleteNotification(stockCode: string): void {
    this.loadContent = false;
    this.watchListService.deleteWatchListNotification(stockCode)
      .subscribe((data: ApiResponse) => {
        if(data.status){
          this.commonService.implementToast(data.responseMessage, "Success");
          this.loadContent = true;
        }else{
          this.commonService.implementToast(data.responseMessage, "Error");
          this.loadContent = true;
        }
      },
        (error: any) => {
          this.commonService.implementToast(error.error.responseMessage, "Error");
          this.loadContent = true;
        });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  close() {
    $('#levelOne').animate({ scrollLeft: -($('.sidebar-loader').width() + $('#watchlist').width()) }, 400);
    this.router.navigateByUrl('/myCarts/watchlist');
  }
}
